import { useLocation, useParams, useHistory } from "react-router-dom"

const retrieveParsedQueryParams = (location) => {
	const rawQueryParams = location.search.split("?").pop()

	const parsedQueryParams = {}

	// It means there are more than one query param on url
	// so we treat it with another logic
	if (rawQueryParams.includes("&")) {
		const params = rawQueryParams.split("&")

		params.forEach(param => {
			const key = param.split("=").shift()
			const value = param.split("=").pop()

			parsedQueryParams[key] = value
		})
	} else {
		const key = rawQueryParams.split("=").shift()
		const value = rawQueryParams.split("=").pop()

		parsedQueryParams[key] = value
	}

	return parsedQueryParams
}

const retrieveRawQueryParams = (location) => {
	return location.search.split("?").pop()
}

const retrieveRouteParams = (params) => {
	return params
}

const makeNavigation = ({ path, keepQueryParams, refreshPage, history, location }) => {
	const queryParams = location.search

	if (keepQueryParams) {
		path = path + queryParams
	}

	if (refreshPage) {
		window.location = `${window.location.origin}${path}`
	} else {
		return history.push(path)
	}
}

const retrievePathName = (location) => {
	const { pathname } = location

	return pathname
}

export const useNavigation = () => {
	const location = useLocation()
	const params = useParams()
	const history = useHistory()

	const getParsedQueryParams = () => {
		return retrieveParsedQueryParams(location)
	}

	const getRawQueryParams = () => {
		return retrieveRawQueryParams(location)
	}

	const getRouteParams = () => {
		return retrieveRouteParams(params)
	}

	const getPathName = () => {
		return retrievePathName(location)
	}

	const navigate = (path, { keepQueryParams, refreshPage } = {}) => {
		return makeNavigation({ path, keepQueryParams, refreshPage, history, location })
	}

	return {
		getParsedQueryParams,
		getRawQueryParams,
		getRouteParams,
		getPathName,
		navigate
	}
}